import React, { useState, useEffect } from 'react'
import InputRange from 'react-input-range'
import 'react-input-range/lib/css/index.css'
import { connect } from 'react-redux'
import {
    applyCurveFilter,
    applyTextureZoom,
} from '../../../redux/tools/actions'
import { Range, getTrackBackground } from 'react-range'
import { values } from 'lodash'
import RangePicker from '../../../components/RangePicker'
import classnames from 'classnames'

const STEP = 0.1
const MIN = 0
const MAX = 100

const MiniEditor = (props) => {
    const [brightness, setBrightness] = useState(-50)
    const [contrast, setContrast] = useState(20)
    const [zoom, setZoom] = useState(100)
    const [offsetH, setOffsetH] = useState(0)
    const [offsetV, setOffsetV] = useState(0)

    const [multiplyIntensity, setMultiplyIntensity] = useState(
        props.multiplyIntensity ?? 0
    )

    useEffect(() => {
        setBrightness(props.brightness)
    }, [props.brightness])

    useEffect(() => {
        setContrast(props.contrast)
    }, [props.contrast])

    useEffect(() => {
        setZoom(props.zoom)
    }, [props.zoom])

    useEffect(() => {
        setOffsetH(props.offsetH)
    }, [props.offsetH])

    useEffect(() => {
        setOffsetV(props.offsetV)
    }, [props.offsetV])

    let miniEditorClassNames = classnames('mini-editor', {
        invisible: !props.isVisible,
    })

    return (
        <div
            className={miniEditorClassNames}
            style={{
                bottom: !props.roomInDesignStage?.selectedPrespectives
                    ? '-185px'
                    : '15px',
            }}
        >
            <div className="mini-editor-option-wrapper w-100">
                <label>فاصله از راست</label>
                <RangePicker
                    step={0.05}
                    value={offsetH}
                    min={0}
                    max={1}
                    onChange={setOffsetH}
                    onFinalChange={() => {
                        props.applyTextureZoom(
                            props.choosedPrespective,
                            props.zoom,
                            offsetH,
                            props.offsetV,
                            props.roomInDesignStage,
                            props.multiply
                        )
                    }}
                />
            </div>
            <div className="mini-editor-option-wrapper w-100">
                <label>فاصله از بالا</label>
                <RangePicker
                    step={0.05}
                    value={offsetV}
                    min={0}
                    max={1}
                    onChange={setOffsetV}
                    onFinalChange={() => {
                        props.applyTextureZoom(
                            props.choosedPrespective,
                            props.zoom,
                            props.offsetH,
                            offsetV,
                            props.roomInDesignStage,
                            props.multiply
                        )
                    }}
                />
            </div>
            <div className="mini-editor-option-wrapper w-100">
                <label>بزرگنمایی</label>
                <RangePicker
                    step={10}
                    value={zoom}
                    min={50}
                    max={250}
                    onChange={setZoom}
                    onFinalChange={() => {
                        props.applyTextureZoom(
                            props.choosedPrespective,
                            zoom,
                            props.offsetH,
                            props.offsetV,
                            props.roomInDesignStage,
                            props.multiply
                        )
                    }}
                />
            </div>
            <div className="mini-editor-option-wrapper w-100">
                <label>روشنایی</label>
                <RangePicker
                    step={10}
                    value={brightness}
                    min={-100}
                    max={100}
                    onChange={setBrightness}
                    onFinalChange={() => {
                        props.applyCurveFilter(
                            props.choosedPrespective,
                            brightness,
                            props.contrast,
                            props.roomInDesignStage,
                            props.multiply
                        )
                    }}
                />
            </div>
            <div className="mini-editor-option-wrapper w-100">
                <label>کنتراست</label>

                <Range
                    values={[contrast]}
                    step={10}
                    min={-100}
                    max={100}
                    onChange={(values) => setContrast(values[0])}
                    onFinalChange={(values) => {
                        props.applyCurveFilter(
                            props.choosedPrespective,
                            props.brightness,
                            contrast,
                            props.roomInDesignStage,
                            props.multiply
                        )
                    }}
                    renderTrack={({ props, children }) => (
                        <div
                            style={{
                                ...props.style,
                                height: '36px',
                                display: 'flex',
                                width: '100%',
                            }}
                        >
                            <div
                                ref={props.ref}
                                style={{
                                    height: '5px',
                                    width: '100%',
                                    borderRadius: '4px',
                                    background: getTrackBackground({
                                        values: [contrast],
                                        colors: ['#1065B0', '#ccc'],
                                        min: -100,
                                        max: 100,
                                    }),
                                    alignSelf: 'center',
                                }}
                            >
                                {children}
                            </div>
                        </div>
                    )}
                    renderThumb={({ props, isDragged }) => (
                        <div
                            {...props}
                            style={{
                                ...props.style,
                                height: '18px',
                                width: '18px',
                                borderRadius: '4px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                background: "url('/images/mokaber-icon.svg')",
                                backgroundSize: 'cover',
                            }}
                        >
                            <div
                                style={{
                                    height: '12px',
                                    width: '5px',
                                }}
                            />
                        </div>
                    )}
                />
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        choosedPrespective: state.tools.choosedPrespective,
        brightness: state.tools.brightness,
        contrast: state.tools.contrast,
        zoom: state.tools.zoom,
        offsetH: state.tools.offsetH,
        offsetV: state.tools.offsetV,
        multiplyIntensity: state.tools.multiplyIntensity,
        roomInDesignStage: state.tools.roomInDesignStage,
        multiply: state.tools.multiply,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        applyCurveFilter: (prespective, brightness, contrast, room, multiply) =>
            dispatch(
                applyCurveFilter(
                    prespective,
                    brightness,
                    contrast,
                    room,
                    multiply
                )
            ),
        applyTextureZoom: (
            prespective,
            zoom,
            offsetH,
            offsetV,
            room,
            multiply
        ) =>
            dispatch(
                applyTextureZoom(
                    prespective,
                    zoom,
                    offsetH,
                    offsetV,
                    room,
                    multiply
                )
            ),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MiniEditor)
